
import './App.css';
import { BrowserRouter, Route, Routes } from "react-router-dom";
import {userRouters} from "./routers/userRouters";

import { useStateContext } from './context/ContextProvider';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
function App() {
  const {
    currentDir,
    setMode,
    currentMode,
    currentLang,
    setCurrentLang,

  } = useStateContext();
  useEffect(() => {
    const currentThemeMode = localStorage.getItem("themeMode");
    if (currentThemeMode) {
      setMode(currentThemeMode);
    }
  }, []);
  const { i18n } = useTranslation()
  useEffect(() => {
   
    const currentThemelang = localStorage.getItem("themeLang");
    if ( currentThemelang) {
      setCurrentLang(currentThemelang);
    }
    i18n.changeLanguage(currentLang);
  }, [currentLang]);
  return (
    <div dir={currentDir} className={currentMode === 'Dark' ? 'dark' : ''}>
      
  <BrowserRouter >
  
          <Routes>
            {userRouters.map((route, index) => (
              <Route
                key={index}
                path={route.path}
                element={route.element} 
              />
            ))}
          </Routes>
  </BrowserRouter>
    
  </div>
  );
}

export default App;
